export default "__VITE_ASSET__CXD448Dt__"